import { render, staticRenderFns } from "./PlanDetailEdit.vue?vue&type=template&id=cbb1cb76&scoped=true"
import script from "./PlanDetailEdit.vue?vue&type=script&lang=ts"
export * from "./PlanDetailEdit.vue?vue&type=script&lang=ts"
import style0 from "./PlanDetailEdit.vue?vue&type=style&index=0&id=cbb1cb76&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbb1cb76",
  null
  
)

export default component.exports